import React, { useEffect, useState } from "react";

function Footer() {
  const [lastScrollY, setLastScrollY] = useState(0);
  const [show, setShow] = useState(true);
  const controlNavbar = () => {
    if (window.scrollY > 2608) {
      setShow(false);
    } else if (window.scrollY <= 2600) {
      setShow(true);
    }
    setLastScrollY(window.scrollY);
  };
  useEffect(() => {
    window.addEventListener("scroll", controlNavbar);
    return () => {
      window.removeEventListener("scroll", controlNavbar);
    };
  }, [lastScrollY]);
  return (
    <div
      className={`bg-black text-white w-full h-[30vh] p-10 flex flex-col justify-center items-center gap-8 fixed bottom-0 `}
    >
      <div className="">
        <img src={require("../images/BABL2.png")} alt="" className="" />
      </div>
      <ul className="flex items-start gap-6 text-[12px] font-semibold uppercase tracking-wide">
        <li className="cursor-pointer border-b-2 border-transparent hover:border-white">
          Home
        </li>
        <li className="cursor-pointer border-b-2 border-transparent hover:border-white">
          Products
        </li>
        <li className="cursor-pointer border-b-2 border-transparent hover:border-white">
          Collections
        </li>
      </ul>
      <div className="relative bg-red-700 w-full grid place-items-center">
        <p className="text-xs text-white/70 font-semibold fixed bottom-8">
          Developed by{" "}
          <a
            href="https://i-portfoliov2.vercel.app/"
            target="_blank"
            rel="noreferrer"
            className="hover:text-white"
          >
            Ikenna Nwobodo{" "}
          </a>
          &copy; 2024
        </p>
      </div>
    </div>
  );
}

export default Footer;
